export class ResetPassword {
  constructor(
    public email: string,
    public newPassword: string,
    public expire: string
  ) {}
}
